import React, { useEffect, useRef } from "react";
import { Box, Button, Typography, Dialog, Fade } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { motion, useAnimation } from "framer-motion";

const SuccessPopup = ({ open, amount, paymentResponse, onClose }) => {
  const controls = useAnimation();
  const checkRef = useRef(null);

  useEffect(() => {
    if (open) {
      controls.start({
        scale: [1, 1.2, 1],
        opacity: [0, 1],
        transition: { duration: 0.8, ease: "easeOut" },
      });
    }
  }, [open, controls]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          background: "linear-gradient(135deg, #1E1E2E 0%, #2A2A3A 100%)",
          boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
          border: "1px solid rgba(255,255,255,0.1)",
          maxWidth: 400,
          width: "100%",
          p: 4,
          overflow: "hidden",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "4px",
            background: "linear-gradient(90deg, #4CAF50 0%, #8BC34A 100%)",
          },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          p: 2,
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 100,
            height: 100,
            mb: 3,
          }}
        >
          {/* Keep the animation code same as before */}
          <motion.div
            animate={controls}
            style={{ position: "relative", zIndex: 1 }}
          >
            <CheckCircle
              ref={checkRef}
              sx={{
                fontSize: 80,
                color: "#4CAF50",
                filter: "drop-shadow(0 0 12px rgba(76, 175, 80, 0.6))",
              }}
            />
          </motion.div>
          <Box
            component={motion.div}
            initial={{ scale: 0 }}
            animate={{
              scale: [0, 1.5],
              opacity: [1, 0],
            }}
            transition={{
              duration: 1.5,
              ease: "easeOut",
              delay: 0.3,
            }}
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              borderRadius: "50%",
              background: "rgba(76, 175, 80, 0.2)",
            }}
          />
        </Box>

        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: "#FFFFFF",
            mb: 1,
          }}
        >
          {paymentResponse?.message || "Payment Successful!"}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "rgba(255,255,255,0.8)",
            mb: 3,
          }}
        >
          ₹{amount} has been added to your wallet
        </Typography>

        {paymentResponse?.payment_id && (
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255,255,255,0.6)",
              mb: 4,
              fontStyle: "italic",
            }}
          >
            Transaction ID: {paymentResponse.payment_id}
          </Typography>
        )}

        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: 2,
            background: "linear-gradient(90deg, #4CAF50 0%, #8BC34A 100%)",
            color: "#FFF",
            fontWeight: 600,
            boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 6px 16px rgba(76, 175, 80, 0.4)",
            },
            transition: "all 0.3s ease",
          }}
        >
          OK
        </Button>
      </Box>
    </Dialog>
  );
};
export default SuccessPopup;
